import { deleteEmailRecipient } from "../../../../../actions/Utilities/EmailRecipient";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteEmailRecipient = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteEmailRecipient(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetEmailRecipient"]);
      queryClient.invalidateQueries(["EmailPermission"]);
      toast.fire(
        "Success",
        "Email Recipient has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Email Recipient",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteEmailRecipient;
